// extracted by mini-css-extract-plugin
module.exports = {"Header":"Admin_Header__1OHUV","CountsStrip":"Admin_CountsStrip__1ca4y"};